/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Modal } from '@components/Modal';
import * as Types from '../../pages/mijn-carel-lurvink/catalogus/stores/types';
import styles from './ProductSymbols.module.scss';

interface IProductSymbols {
  symbols: Types.MappedProductSymbol[];
}

export const ProductSymbols = ({ symbols }: IProductSymbols) => {
  const { t } = useTranslation('product-details');

  const [symbolModal, setSymbolModal] = useState<{ title: string; body: string }>();

  const handleSymbolClick = async (symbol: Types.MappedProductSymbol) => {
    if (!symbol.url) {
      return;
    }

    const iframeHtml = `
      <iframe
        class="border-0 mt-3" src="${symbol.url}?design=SymbolBlank"
        height="500px" width="100%"
      ></iframe>`;

    setSymbolModal({
      title: symbol.value,
      body: iframeHtml
    });
  };

  return (
    <>
      <Modal
        // Needs to be rendered within SlidePane otherwise `useClickOutside`
        // is triggered when closing the modal, also closing the Slidepane
        // @ts-expect-error: See comments
        container={document.querySelector('#portal [class*=SlidePane]')}
        onCloseModal={() => setSymbolModal(undefined)}
        BodyComponent={<div dangerouslySetInnerHTML={{ __html: symbolModal?.body ?? '' }} />}
        showModal={!!symbolModal?.body}
        showHeader={false}
        buttons={[
          {
            variant: 'primary',
            label: t('common:button.close'),
            onClick: () => setSymbolModal(undefined),
            className: 'btn-fixed px-3 mr-3'
          }
        ]}
      />

      <h3 className="h2 mb-2">{t('title.symbols')}</h3>

      {symbols.map((symbol, idx) => {
        return (
          <a
            href={`${symbol.url}?design=SymbolBlank`}
            onClick={(e) => {
              e.preventDefault();
              handleSymbolClick(symbol);
            }}
            target="_blank"
            className="mr-3"
            key={`${symbol.code}-${idx}`}
          >
            <img src={symbol.image} alt={symbol.value} className={styles.symbolImage} />
          </a>
        );
      })}
    </>
  );
};
